"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'whatsapp.settingsList.title': 'Communication Agents',
    'whatsapp.settingsList.add': 'Add Phone Number',
    'whatsapp.settingsList.empty': 'No phone numbers configured. Add one to get started.',
    'whatsapp.settingsList.language': 'Language',
    'whatsapp.settingsList.avatar': 'Avatar',
    'whatsapp.settingsList.actions': 'Actions',
    'whatsapp.settingsList.loadFailed': 'Failed to load WhatsApp configurations.',
    'whatsapp.settingsList.deleteConfirm': 'Are you sure you want to delete this WhatsApp configuration?',
    'whatsapp.settingsList.deleted': 'WhatsApp configuration deleted.',
    'whatsapp.settingsList.deleteFailed': 'Failed to delete WhatsApp configuration.',
};
